import { Box, Typography, Button, IconButton } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";
import { X } from "lucide-react";
import { SxProps } from "@mui/system";

export default ({
  eyebrowText,
  title,
  subtext,
  buttonText,
  buttonIcon,
  buttonVariant = "contained",
  dismissible = false,
  onDismiss,
  onClick,
  sx,
  noMarginBottom = false,
}: {
  title: string;
  eyebrowText?: string;
  subtext?: string | React.ReactNode;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  buttonVariant?: "contained" | "text" | "outlined";
  dismissible?: boolean;
  onDismiss?: () => void;
  onClick?: () => void;
  sx?: SxProps;
  noMarginBottom?: boolean;
}) => {
  const isMobile = useIsMobile();

  // Both variants now use horizontal layout with button on the right
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: isMobile ? "start" : "center",
        flexDirection: isMobile ? "column" : "row",
        gap: "12px",
        justifyContent: "space-between",
        padding: isMobile ? "16px" : "16px 24px",
        backgroundColor: isMobile ? "rgba(255, 255, 255, 0.70)" : "#FFF",
        borderRadius: "12px",
        border: "1px solid #D4D4D4",
        marginBottom: noMarginBottom ? "0px" : "12px",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {eyebrowText && (
          <Typography variant={"bodyHeavy"} sx={{ color: "#198282" }}>
            {eyebrowText}
          </Typography>
        )}
        <Typography variant={"h4"}>{title}</Typography>
        {subtext && typeof subtext === "string" ? (
          <Typography variant={"body"}>{subtext}</Typography>
        ) : (
          subtext
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: "8px",
          ...(isMobile && { justifyContent: "space-between", width: "100%" }),
        }}
      >
        {buttonText && (
          <Button
            variant={buttonVariant}
            onClick={onClick}
            sx={{
              whiteSpace: "nowrap",
            }}
            startIcon={isMobile ? undefined : buttonIcon}
          >
            {buttonText}
          </Button>
        )}

        {dismissible &&
          (isMobile ? (
            <Button
              variant="text"
              onClick={onDismiss}
              sx={{ whiteSpace: "nowrap", color: "text.secondary" }}
            >
              Dismiss
            </Button>
          ) : (
            <IconButton
              onClick={onDismiss}
              sx={{ whiteSpace: "nowrap", color: "text.tertiary" }}
            >
              <X size={20} />
            </IconButton>
          ))}
      </Box>
    </Box>
  );
};
